import { GridItemNormalizer } from '../types';

export default class ObjectGridItemNormalizer implements GridItemNormalizer {
  support(value: any): boolean {
    return Boolean(value?.name);
  }

  normalize(value: any) {
    return value?.name;
  }

  normalizeAsSelectValue(value: any) {
    return this.normalize(value);
  }

  getRequiredFields() {
    return {
      id: '',
      name: '',
    };
  }
}
